<template><section><template>
<h3>导航</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-nav :default-active="activeIndex" mode="horizontal" @select="handleSelect">
<n3-nav-item index="1">导航一</n3-nav-item>
<n3-sub-nav index="2">
<template slot="title">导航二</template>
<n3-nav-item index="2-1">选项1</n3-nav-item>
<n3-nav-item index="2-2">选项2</n3-nav-item>
<n3-nav-item index="2-3">选项3</n3-nav-item>
</n3-sub-nav>
<n3-nav-item index="3"><a href="#" target="_blank">导航三</a></n3-nav-item>
</n3-nav>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-nav</span>  <span class="hljs-attr">:default-active</span>=<span class="hljs-string">"activeIndex"</span>  <span class="hljs-attr">mode</span>=<span class="hljs-string">"horizontal"</span> <span class="hljs-attr">@select</span>=<span class="hljs-string">"handleSelect"</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"1"</span>&gt;</span>导航一<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-sub-nav</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2"</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"title"</span>&gt;</span>导航二<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2-1"</span>&gt;</span>选项1<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2-2"</span>&gt;</span>选项2<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2-3"</span>&gt;</span>选项3<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-sub-nav</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"3"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">a</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"#"</span> <span class="hljs-attr">target</span>=<span class="hljs-string">"_blank"</span>&gt;</span>导航三<span class="hljs-tag">&lt;/<span class="hljs-name">a</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav</span>&gt;</span>
</code></pre>
<n3-nav default-active="2" theme="dark" @open="handleOpen" @close="handleClose" :style="{width:'180px'}">
<n3-sub-nav index="1">
<template slot="title"><n3-icon type="bars"></n3-icon>导航一</template>
<n3-nav-group key="1">
<template slot="title">分组一</template>
<n3-nav-item index="1-1" key="1-1">选项1</n3-nav-item>
<n3-nav-item index="1-2" key="1-2">选项2</n3-nav-item>
</n3-nav-group>
<n3-nav-group title="分组2" key="2">
<n3-nav-item index="1-3" key="1-2">选项3</n3-nav-item>
</n3-nav-group>
<n3-sub-nav index="1-4">
<template slot="title">选项4</template>
<n3-nav-item index="1-4-1">选项1</n3-nav-item>
</n3-sub-nav>
</n3-sub-nav>
<n3-nav-item index="2"><n3-icon type="eye"></n3-icon>导航二</n3-nav-item>
<n3-nav-item index="3"><n3-icon type="cloud"></n3-icon>导航三</n3-nav-item>
</n3-nav>
</div>
<h3>n3-nav参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>mode</td>
<td>String</td>
<td>horizontal,vertical</td>
<td>vertical</td>
</tr>
<tr>
<td>theme</td>
<td>String</td>
<td>light,dark</td>
<td>light</td>
</tr>
<tr>
<td>default-active</td>
<td>String</td>
<td>-</td>
<td>当前激活菜单的index</td>
</tr>
<tr>
<td>default-openeds</td>
<td>Array</td>
<td>—</td>
<td>当前打开的submenu的 key 数组	Array</td>
</tr>
<tr>
<td>unique-opened</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>menu-trigger</td>
<td>String</td>
<td>hover</td>
<td>子菜单打开的触发方式(只在 mode 为 horizontal 时有效)</td>
</tr>
<tr>
<td>router</td>
<td>Boolean</td>
<td>false</td>
<td>vue-router 的模式，启用该模式会在激活导航时以 index 作为 path 进行路由跳转</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>事件</th>
<th>说明类</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>select</td>
<td>菜单激活回调	index: 选中菜单项的</td>
<td>indexPath: 选中菜单项的 index path</td>
</tr>
<tr>
<td>open</td>
<td>SubMenu 展开的回调</td>
<td>index: 打开的 subMenu 的 index， indexPath: 打开的 subMenu 的 index path</td>
</tr>
<tr>
<td>close</td>
<td>SubMenu 收起的回调</td>
<td>index: 收起的 subMenu 的 index， indexPath: 收起的 subMenu 的 index path</td>
</tr>
</tbody>
</table>
<h3>n3-sub-nav参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>index</td>
<td>String</td>
<td>-</td>
<td></td>
</tr>
</tbody>
</table>
<h3>n3-nav-item参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>index</td>
<td>String</td>
<td>-</td>
<td></td>
</tr>
<tr>
<td>route</td>
<td>Object</td>
<td>-</td>
<td>Vue Router 路径对象</td>
</tr>
</tbody>
</table>
<h3>n3-nav-group参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>String</td>
<td>-</td>
<td>分组</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      activeIndex: 1,
      show2: false
    }
  },
  methods:{
    handleSelect(){

    },
    handleOpen(){

    },
    handleClose(){

    }
  }
}
</script>


// WEBPACK FOOTER //
// n3NavDocs.md?e5fb586c